import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "employess" }
const _hoisted_8 = { class: "uppercase" }

import store from "@/store";
import { computed, ref, watchEffect } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";
import { base64ToFile } from "@/common/utils/files";

import { companyGet, companyUpdate } from "@/common/api/rest/company";
import {
  addressList,
  addressCreate,
  addressUpdate,
  addressDelete,
} from "@/common/api/rest/address";
import {
  contactList,
  contactCreate,
  contactUpdate,
  contactDelete,
} from "@/common/api/rest/contact";
import {
  fileAvatarCreate,
  fileAvatarUpdate,
  fileAvatarDelete,
} from "@/common/api/rest/file/avatar";
import {
  employeeCreate,
  employeeList,
  employeUpload,
  employeModelCSV,
  employeeShow,
  employeeUpdate,
  employeeDelete,
} from "@/common/api/rest/employee";

import { CompanyType, type CompanyPayloadType } from "@/common/types/company";
import type { AddressType, ContactType, FileType } from "@/common/types/common";
import type {
  EmployeePayloadType,
  EmployeeListType,
} from "@/common/types/employee";

import { RegisterTheme } from "@/common/themes";

import {
  svgIcon,
  iconMenu,
  baseTable,
  baseConfirm,
  baseModal,
} from "@/common/components";

import {
  fileUploadForm,
  companyForm,
  addressForm,
  contactForm,
  employeeForm,
} from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[company]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const addressData = ref<AddressType[]>([]);
const contactData = ref<AddressType[]>([]);
const employeeData = ref<EmployeeListType[]>([]);

const selectedMenu = ref<string>("home");
const companyData = ref<CompanyType | null>(null);
const companyPayload = ref<CompanyPayloadType | null>(null);
const addressPayload = ref<AddressType | null>(null);
const contactPayload = ref<ContactType | null>(null);
const employeePayload = ref<EmployeePayloadType | null>(null);

const selectedAddress = ref<AddressType | null>(null);
const selectedContact = ref<ContactType | null>(null);
const selectedEmployee = ref<EmployeeListType | null>(null);

const fileEmployee = ref<FileType | null>(null);
const fileExtensions = ref(["csv"]);

const addressEdit = ref(false);
const showModalAddress = ref(false);
const showDelAddress = ref(false);

const contactEdit = ref(false);
const showModalContact = ref(false);
const showDelContact = ref(false);

const employeeEdit = ref(false);
const showModalFileEmployee = ref(false);
const showModalEmployee = ref(false);
const showDelEmployee = ref(false);

const showDelAvatar = ref(false);

const addressLimit = ref<number>(5);
const addressPage = ref<number>(0);
const addressPages = ref<number>(0);
const addressSearch = ref<string>("");
const addressSearched = ref<number>(0);
const addressTotal = ref<number>(0);

const contactLimit = ref<number>(5);
const contactPage = ref<number>(0);
const contactPages = ref<number>(0);
const contactSearch = ref<string>("");
const contactSearched = ref<number>(0);
const contactTotal = ref<number>(0);

const employeeLimit = ref<number>(5);
const employeePage = ref<number>(0);
const employeePages = ref<number>(0);
const employeeSearch = ref<string>("");
const employeeSearched = ref<number>(0);
const employeeTotal = ref<number>(0);

const accountId = computed(() => String(route.params.id));
const companyId = computed(() => String(route.params.company));

const addressHeader = computed(() => [
  { key: "name", label: t("common.labels.name") },
  { key: "address", label: t("common.labels.address") },
  { key: "cep", label: t("common.labels.cep") },
]);

const contactHeader = computed(() => [
  { key: "name", label: t("common.labels.name") },
  { key: "type", label: t("common.labels.type") },
  { key: "contact", label: t("common.labels.contact") },
]);

const employeeHeader = computed(() => [
  { key: "name", label: t("common.labels.name") },
  { key: "role", label: t("common.labels.role") },
  { key: "sector", label: t("common.labels.sector") },
  { key: "status", label: t("common.labels.status") },
]);

const modalAddressTitle = computed(() =>
  addressEdit.value
    ? t("common.labels.edit", {
        concat: t("common.labels.address"),
      }).toUpperCase()
    : t("common.labels.add", {
        concat: t("common.labels.address"),
      }).toUpperCase(),
);

const modalContactTitle = computed(() =>
  addressEdit.value
    ? t("common.labels.edit", {
        concat: t("common.labels.contact"),
      }).toUpperCase()
    : t("common.labels.add", {
        concat: t("common.labels.contact"),
      }).toUpperCase(),
);

const modalEmployeeTitle = computed(() =>
  employeeEdit.value
    ? t("common.labels.edit", {
        concat: t("common.labels.employee"),
      }).toUpperCase()
    : t("common.labels.add", {
        concat: t("common.labels.employee"),
      }).toUpperCase(),
);

const menuTabs = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.company"),
  },
  {
    key: "address",
    icon: "pin",
    label: t("common.labels.address"),
  },
  {
    key: "contact",
    icon: "phone",
    label: t("common.labels.contacts"),
  },
  {
    key: "employee",
    icon: "card",
    label: t("common.labels.employees"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/company`);
}

function fetchCompany() {
  companyGet(accountId.value, companyId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        companyData.value = data;

        companyPayload.value = {
          name: data.name,
          fantasy_name: data.fantasy_name,
          description: data.description,
          document_number: data.document_number,
          document_name: data.document_name,
          document_type: data.document_type,
          cnae: data.cnae,
          danger: data.danger?.toString(),
          number_of_employee: data.number_of_employee,
        };

        addressData.value = data.address;
        contactData.value = data.contacts;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateCompany(data: CompanyPayloadType) {
  companyUpdate(accountId.value, companyId.value, data)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCompany();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// ADDRESS

function fetchAddress() {
  addressList(accountId.value, companyId.value, {
    page: addressPage.value,
    limit: addressLimit.value,
    search: addressSearch.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        addressData.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addAddress() {
  addressEdit.value = false;
  showModalAddress.value = true;
}

function addressCancel() {
  addressEdit.value = false;
  showModalAddress.value = false;
  addressPayload.value = null;
}

function addAddressConfirm() {
  if (!addressPayload.value) return;

  showModalAddress.value = false;
  store.commit("SET_LOADING", true);

  addressCreate(accountId.value, companyId.value, addressPayload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchAddress();
        addressCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalAddress.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalAddress.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function updateAddress(data: AddressType) {
  selectedAddress.value = data;
  addressPayload.value = data;
  showModalAddress.value = true;
  addressEdit.value = true;
}

function updateAddressConfirm() {
  if (!selectedAddress.value) return;

  showModalAddress.value = false;
  store.commit("SET_LOADING", true);

  addressUpdate(
    accountId.value,
    selectedAddress.value.address_id as string,
    addressPayload.value as AddressType,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchAddress();
        addressCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function submitAddress() {
  if (!addressEdit.value) {
    addAddressConfirm();
  } else {
    updateAddressConfirm();
  }
}

function removeAddress(data: AddressType) {
  selectedAddress.value = data;
  showDelAddress.value = true;
}

function removeAddressCancel() {
  selectedAddress.value = null;
  showDelAddress.value = false;
}

function removeAddressConfirm() {
  if (!selectedAddress.value) return;

  showModalAddress.value = false;
  store.commit("SET_LOADING", true);

  addressDelete(accountId.value, selectedAddress.value.address_id as string)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchAddress();
        removeAddressCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

// CONTACT

function fetchContacts() {
  contactList(accountId.value, companyId.value, {
    page: contactPage.value,
    limit: contactLimit.value,
    search: contactSearch.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        contactData.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addContact() {
  showModalContact.value = true;
}

function contactCancel() {
  contactEdit.value = false;
  showModalContact.value = false;
  contactPayload.value = null;
}

function addContactConfirm() {
  if (!contactPayload.value) return;

  showModalContact.value = false;
  store.commit("SET_LOADING", true);

  contactCreate(accountId.value, companyId.value, contactPayload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchContacts();
        contactCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalContact.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalContact.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function updatedContact(data: ContactType) {
  contactEdit.value = true;
  contactPayload.value = data;
  selectedContact.value = data;
  showModalContact.value = true;
}

function updatedContactConfirm() {
  if (!contactPayload.value && !selectedContact.value) return;

  showModalContact.value = false;
  store.commit("SET_LOADING", true);

  contactUpdate(
    accountId.value,
    selectedContact.value?.contact_id as string,
    contactPayload.value as ContactType,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchContacts();
        contactCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalContact.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalContact.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function submitContact() {
  if (!contactEdit.value) {
    addContactConfirm();
  } else {
    updatedContactConfirm();
  }
}

function removeContact(data: ContactType) {
  selectedContact.value = data;
  showDelContact.value = true;
}

function removeContactCancel() {
  selectedContact.value = null;
  showDelContact.value = false;
}

function removeContactConfirm() {
  if (!selectedContact.value) return;

  showDelContact.value = false;
  store.commit("SET_LOADING", true);

  contactDelete(accountId.value, selectedContact.value?.contact_id as string)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchContacts();
        removeContactCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

// EMPLOYESS

function fecthEmployees() {
  employeeList(accountId.value, companyId.value, {
    page: employeePage.value,
    search: employeeSearch.value,
    limit: employeeLimit.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        employeeData.value = data.list;
        employeePage.value = data.infos.page;
        employeePages.value = data.infos.pages;
        employeeTotal.value = data.infos.total;
        employeeSearched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addEmployee() {
  showModalEmployee.value = true;
}

function addEmployeeCancel() {
  showModalEmployee.value = false;
  selectedEmployee.value = null;
  employeePayload.value = null;
}

function addEmployeeConfirm() {
  if (!employeePayload.value) return;

  showModalEmployee.value = false;
  store.commit("SET_LOADING", true);

  employeeCreate(accountId.value, companyId.value, employeePayload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthEmployees();
        addEmployeeCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalEmployee.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalEmployee.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function editEmployee(employee: EmployeeListType) {
  selectedEmployee.value = employee;

  employeeShow(accountId.value, employee.employee_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        showModalEmployee.value = true;
        employeeEdit.value = true;
        employeePayload.value = {
          ...data,
        };
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function editEmployeeConfirm() {
  if (!selectedEmployee.value || !employeePayload.value) return;
  showModalEmployee.value = false;
  store.commit("SET_LOADING", true);

  employeeUpdate(
    accountId.value,
    selectedEmployee.value.employee_id,
    employeePayload.value,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthEmployees();
        addEmployeeCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalEmployee.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalEmployee.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function removeEmployee(value: EmployeeListType) {
  showDelEmployee.value = true;
  selectedEmployee.value = value;
}

function removeEmployeeCancel() {
  showDelEmployee.value = false;
  selectedEmployee.value = null;
}

function removeEmployeeConfirm() {
  if (!selectedEmployee.value) return;

  showModalEmployee.value = false;
  store.commit("SET_LOADING", true);

  employeeDelete(accountId.value, selectedEmployee.value.employee_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthEmployees();
        removeEmployeeCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function submitEmployee() {
  if (employeeEdit.value) {
    editEmployeeConfirm();
  } else {
    addEmployeeConfirm();
  }
}

function searchEmployee(value: string) {
  employeeSearch.value = value;
  fecthEmployees();
}

function changePageEmployee(value: number) {
  employeePage.value = value;
  fecthEmployees();
}

function uploadEmployee() {
  showModalFileEmployee.value = true;
}

function uploadEmployeeCancel() {
  showModalFileEmployee.value = false;
  fileEmployee.value = null;
}

function uploadEmployeeConfirm() {
  if (!fileEmployee.value) return;

  store.commit("SET_LOADING", true);

  employeUpload(accountId.value, companyId.value, fileEmployee.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthEmployees();
        uploadEmployeeCancel();
        toast({ message: message, type: "success" });
      } else {
        showModalFileEmployee.value = true;
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function downloadEmployeeModel() {
  employeModelCSV(accountId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        base64ToFile(data.file, data.name, data.type);
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addAvatar(file: string) {
  fileAvatarCreate(accountId.value, {
    owner_id: companyId.value,
    type: "COMPANY",
    file,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCompany();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateAvatar(file: string) {
  if (!companyData.value?.avatar) return;

  fileAvatarUpdate(accountId.value, companyData.value.avatar.avatar_id, {
    file,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCompany();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeAvatar(avatar: string) {
  if (companyData.value?.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showDelAvatar.value = true;
}

function delAvatarConfirm() {
  if (!companyData.value?.avatar) return;

  fileAvatarDelete(accountId.value, companyData.value!.avatar.avatar_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCompany();
        showDelAvatar.value = false;
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const debounceForm = debounce(updateCompany, 1000);

watchEffect(() => {
  console.log("selectedMenu", selectedMenu.value);

  if (companyId.value) {
    if (selectedMenu.value === "home") {
      fetchCompany();
    } else if (selectedMenu.value === "address") {
      fetchAddress();
    } else if (selectedMenu.value === "contact") {
      fetchContacts();
    } else if (selectedMenu.value === "employee") {
      fecthEmployees();
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(RegisterTheme), { "tab-active": "company" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(svgIcon), {
              icon: "company",
              size: "2rem"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.company") })), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-back btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1.25rem"
            })
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(iconMenu), {
          tabs: menuTabs.value,
          active: selectedMenu.value,
          onSelected: _cache[6] || (_cache[6] = ($event: any) => (selectedMenu.value = $event))
        }, {
          content: _withCtx(() => [
            (selectedMenu.value === 'home')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("common.labels.company")), 1),
                  _createVNode(_unref(companyForm), {
                    width: "100%",
                    data: companyPayload.value,
                    "show-avatar": true,
                    avatar: companyData.value?.avatar?.small,
                    onUpdateData: _unref(debounceForm),
                    onAvatarAdd: changeAvatar,
                    onAvatarDel: _cache[1] || (_cache[1] = ($event: any) => (delAvatar()))
                  }, null, 8, ["data", "avatar", "onUpdateData"])
                ], 64))
              : _createCommentVNode("", true),
            (selectedMenu.value === 'address')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("common.labels.address")), 1),
                  _createVNode(_unref(baseTable), {
                    header: addressHeader.value,
                    data: addressData.value,
                    paginated: false,
                    "show-search": false,
                    options: true,
                    edit: true,
                    del: true,
                    "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (addAddress())),
                    "onBtn:edit": updateAddress,
                    "onBtn:del": removeAddress
                  }, {
                    address: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.city) + " - " + _toDisplayString(data.state), 1)
                    ]),
                    _: 1
                  }, 8, ["header", "data"])
                ], 64))
              : _createCommentVNode("", true),
            (selectedMenu.value === 'contact')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("common.labels.contact")), 1),
                  _createVNode(_unref(baseTable), {
                    header: contactHeader.value,
                    data: contactData.value,
                    paginated: false,
                    "show-search": false,
                    options: true,
                    edit: true,
                    del: true,
                    "onBtn:add": _cache[3] || (_cache[3] = ($event: any) => (addContact())),
                    "onBtn:edit": updatedContact,
                    "onBtn:del": removeContact
                  }, {
                    type: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(_unref(t)(`common.labels.${data.type}`)), 1)
                    ]),
                    _: 1
                  }, 8, ["header", "data"])
                ], 64))
              : _createCommentVNode("", true),
            (selectedMenu.value === 'employee')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("common.labels.employees")), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(baseTable), {
                      header: employeeHeader.value,
                      data: employeeData.value,
                      page: employeePage.value,
                      pages: employeePages.value,
                      total: employeeTotal.value,
                      searched: employeeSearched.value,
                      limit: employeeLimit.value,
                      paginated: true,
                      "show-search": true,
                      options: true,
                      edit: true,
                      del: true,
                      add: true,
                      upload: true,
                      "onBtn:add": _cache[4] || (_cache[4] = ($event: any) => (addEmployee())),
                      "onBtn:edit": editEmployee,
                      "onBtn:del": removeEmployee,
                      "onBtn:upload": _cache[5] || (_cache[5] = ($event: any) => (uploadEmployee())),
                      "onChange:page": changePageEmployee,
                      onSearching: searchEmployee
                    }, {
                      status: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)(`common.labels.${data.status.toLowerCase()}`)), 1)
                      ]),
                      _: 1
                    }, 8, ["header", "data", "page", "pages", "total", "searched", "limit"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tabs", "active"])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseModal), {
      show: showModalAddress.value,
      title: modalAddressTitle.value,
      "show-button-confirm": true,
      "button-confirm": 
      addressEdit.value ? _unref(t)('common.labels.save') : _unref(t)('common.labels.add')
    ,
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (addressCancel())),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (submitAddress()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(addressForm), {
          data: addressPayload.value,
          onUpdateData: _cache[7] || (_cache[7] = ($event: any) => (addressPayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelAddress.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.company') }),
      message: 
      _unref(t)('common.texts.remove_message', { concat: selectedAddress.value?.name })
    ,
      onCancel: removeAddressCancel,
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (removeAddressConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalContact.value,
      title: modalContactTitle.value,
      "show-button-confirm": true,
      "button-confirm": 
      contactEdit.value ? _unref(t)('common.labels.save') : _unref(t)('common.labels.add')
    ,
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[12] || (_cache[12] = ($event: any) => (contactCancel())),
      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (submitContact()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(contactForm), {
          data: contactPayload.value,
          onUpdateData: _cache[11] || (_cache[11] = ($event: any) => (contactPayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseModal), {
      show: showModalEmployee.value,
      title: modalEmployeeTitle.value,
      "show-button-confirm": true,
      "button-confirm": 
      employeeEdit.value ? _unref(t)('common.labels.save') : _unref(t)('common.labels.add')
    ,
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[15] || (_cache[15] = ($event: any) => (addEmployeeCancel())),
      onConfirm: _cache[16] || (_cache[16] = ($event: any) => (submitEmployee()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(employeeForm), {
          data: employeePayload.value,
          onUpdateData: _cache[14] || (_cache[14] = ($event: any) => (employeePayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseModal), {
      show: showModalFileEmployee.value,
      title: 
      _unref(t)('common.labels.upload', {
        concat: _unref(t)('common.labels.employees'),
      }).toUpperCase()
    ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.send'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (uploadEmployeeCancel())),
      onConfirm: _cache[20] || (_cache[20] = ($event: any) => (uploadEmployeeConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(fileUploadForm), {
          extensions: fileExtensions.value,
          model: true,
          onUpdateData: _cache[17] || (_cache[17] = ($event: any) => (fileEmployee.value = $event)),
          onModelDownload: _cache[18] || (_cache[18] = ($event: any) => (downloadEmployeeModel()))
        }, null, 8, ["extensions"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelContact.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.contact') }),
      message: 
      _unref(t)('common.texts.remove_message', { concat: selectedContact.value?.name })
    ,
      onCancel: removeContactCancel,
      onConfirm: _cache[21] || (_cache[21] = ($event: any) => (removeContactConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelEmployee.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.employee') }),
      message: 
      _unref(t)('common.texts.remove_message', { concat: selectedEmployee.value?.name })
    ,
      onCancel: removeEmployeeCancel,
      onConfirm: _cache[22] || (_cache[22] = ($event: any) => (removeEmployeeConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelAvatar.value,
      title: _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.avatar') }),
      message: 
      _unref(t)('common.texts.remove_message', { concat: _unref(t)('common.labels.avatar') })
    ,
      onCancel: _cache[23] || (_cache[23] = ($event: any) => (showDelAvatar.value = false)),
      onConfirm: _cache[24] || (_cache[24] = ($event: any) => (delAvatarConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})